var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-999 1001 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-960.8,1112.9l4.7-11.9H-978l3.8,11.9H-960.8z M-967,1161.8c13.1,0,23.7-10.7,23.7-23.7c0-9.2-5.3-17.2-12.9-21.2v-0.1 h-21.9v0.1c-7.7,4-12.8,11.9-12.8,21.2C-990.9,1151.1-980.2,1161.8-967,1161.8z M-968.3,1140.9c-3.6-1.1-6-2.8-6-6.1 c0-3,2.1-5.3,5.7-6v-3.1h3.3v3c2.3,0.1,3.7,0.6,4.8,1.1l-1,3.7c-0.9-0.4-2.4-1.1-4.8-1.1c-2.1,0-2.8,1-2.8,1.8c0,1.1,1.1,1.8,4,2.8 c4,1.4,5.5,3.3,5.5,6.2s-2.1,5.5-6,6.1v3.4h-3.3v-3.1c-2.3-0.1-4.4-0.7-5.7-1.4l1-3.8c1.4,0.7,3.4,1.4,5.5,1.4 c1.8,0,3.1-0.7,3.1-2.1C-964.8,1142.5-965.9,1141.8-968.3,1140.9z M-871.2,1110.4c15.5,0,28-12.5,28-28s-12.4-28-28-28 c-15.5,0-28,12.5-28,28C-899.1,1098-886.6,1110.4-871.2,1110.4z M-936.2,1191.5h-50.3c-16.3,0-17.2-24.9,0.3-24.9h43.6l25-36.8 c7.4-10.1,15.8-14.9,27.7-14.9h37.3c11.9,0,20.3,4.4,27.7,14.9l25.1,36.8h43.9c17.6,0,16.5,24.9,0.6,24.9h-50.3 c-4,0-8.8-1.4-11.6-5.7l-19.2-27.4l-0.1,68.6h-68.8l-0.1-68.6l-19.2,27.4C-927.4,1190-932.2,1191.5-936.2,1191.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -773.9,
    cy: 1102.6,
    r: 5.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-780.1,1158.8c0,1.6,1.3,3,3,3c1.6,0,3-1.3,3-3v-24.7h1.3l0,24.7c0,1.6,1.3,3,3,3c1.6,0,3-1.3,3-3l0-42.7h1.3v15.7 c0,3.2,4.1,3.2,4.1,0v-16.1c0-3.5-2-6.9-6.1-6.9h-11.8c-3.7,0-6.1,3-6.1,6.8v16.2c0,3.1,4.1,3.1,4.1,0v-15.7h1.3L-780.1,1158.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecision);
export default __webpack_public_path__ + "static/media/decision.13d758547792bd1d68186ab4d877e9ca.svg";
export { ForwardRef as ReactComponent };